import { render } from "./WordList.vue?vue&type=template&id=9f63df36"
import script from "./WordList.vue?vue&type=script&lang=ts"
export * from "./WordList.vue?vue&type=script&lang=ts"

import "./WordList.vue?vue&type=style&index=0&id=9f63df36&lang=less"
script.render = render

export default script